import globalConfig from '@utiles/officialStore/globalConfig';

/** SDK 自行注入 iframe query，勿从宿主页透传 */
const EXCLUDED_PASSTHROUGH_KEYS = new Set(['chatAppId', 'sdkVersion']);

/**
 * 收集当前页 search + hash 上的 query（后者同名覆盖前者）
 * @returns {Record<string, string>}
 */
export function getPageHrefParams() {
  if (typeof window === 'undefined') return {};
  let search = window.location.search.replace(/^\?/, '');
  const hashParts = window.location.hash.split('?');
  if (hashParts.length > 1) {
    hashParts.splice(0, 1);
    const hashQuery = hashParts.join('&').replace(/^\?/, '');
    if (hashQuery) {
      search = search ? `${search}&${hashQuery}` : hashQuery;
    }
  }
  /** @type {Record<string, string>} */
  const result = {};
  if (!search) return result;
  new URLSearchParams(search).forEach((value, key) => {
    result[key] = value;
  });
  return result;
}

/**
 * 构建 Chat App iframe URL：透传宿主页 query + 当前语言 + gameId
 * 首屏语言走 URL；热切换走 SDK updateConfig({ lang })，避免 iframe remount
 *
 * @param {string} baseUrl
 * @param {{ lang?: string, gameId?: string|number, loginAccount?: string }} [options]
 * @returns {string}
 */
export function buildPayAssistantChatAppUrl(baseUrl, options = {}) {
  const { lang, gameId, loginAccount } = options;
  if (!baseUrl) return '';

  try {
    const url = new URL(
      baseUrl,
      typeof window !== 'undefined' ? window.location.href : undefined,
    );
    const pageParams = getPageHrefParams();

    Object.entries(pageParams).forEach(([key, value]) => {
      if (EXCLUDED_PASSTHROUGH_KEYS.has(key)) return;
      if (value != null && value !== '') {
        url.searchParams.set(key, value);
      }
    });

    if (gameId != null && gameId !== '') {
      url.searchParams.set('gameId', String(gameId));
    }

    const resolvedLoginAccount =
      loginAccount ||
      pageParams.loginAccount ||
      (typeof globalConfig.getHrefParam === 'function'
        ? globalConfig.getHrefParam('loginAccount')
        : '') ||
      '';
    if (resolvedLoginAccount) {
      url.searchParams.set('loginAccount', resolvedLoginAccount);
    }

    const resolvedLang =
      lang ||
      (typeof globalConfig.getLanguages === 'function'
        ? globalConfig.getLanguages()
        : '') ||
      pageParams.language ||
      'en-US';
    url.searchParams.set('language', resolvedLang);
    url.searchParams.set(
      'appLanguage',
      pageParams.appLanguage ||
      (typeof globalConfig.getHrefParam === 'function'
        ? globalConfig.getHrefParam('appLanguage')
        : '') ||
      resolvedLang,
    );

    return url.toString();
  } catch (e) {
    console.warn('[PayAssistant] buildPayAssistantChatAppUrl failed', e);
    return baseUrl;
  }
}

/**
 * @returns {string}
 */
export function getDefaultChatAppBaseUrl() {
  const host =
    typeof window !== 'undefined' && typeof globalConfig.getMainHost === 'function'
      ? globalConfig.getMainHost()
      : '37games.com';
  return `https://gabres.${host}/aiGameBuddy/chat-app-pay-assistant/index.html`;
}
